import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { Button } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { Tech3Input } from '../../../components/FormElements';
import { loginWithCredentials } from '../../../data/actions';

const Login = props => {
  const { error, handleSubmit, submitting } = props;

  const style = {
    position: 'fixed',
    top: '50%',
    left: '50%',
    width: '30em',
    height: '18em',
    marginTop: '-9em',
    marginLeft: '-15em'
  };

  const errorStyle = {
    width: '100%',
    border: '1px solid #F00',
    backgroundColor: '#ff9999',
    padding: '10px',
    borderRadius: '5px',
    marginBottom: '10px'
  };

  const login = payload => {
    return props.dispatch(
      loginWithCredentials(payload, () => {
        if (props.location.state) {
          props.history.push(props.location.state.from.pathname);
        } else {
          props.history.push('/');
        }
      })
    );
  };

  return (
    <div style={style}>
      <h4> Login </h4>
      {error && (
        <div style={errorStyle} className="error">
          {error}
        </div>
      )}
      <form onSubmit={handleSubmit(login)}>
        <Field name="username" type="text" component={Tech3Input} label="Username" />
        <Field name="password" type="password" component={Tech3Input} label="Password" />

        <div style={{ marginTop: '10px' }}>
          <Button type="submit" loading={submitting}>
            Log In
          </Button>
        </div>
      </form>
    </div>
  );
};

const loginForm = reduxForm({
  form: 'submitValidation' // a unique identifier for this form
})(Login);

export default connect(
  state => ({
    alerts: state.app.alerts
  }),
  null,
  (propsFromState, propsFromDispatch, ownProps) => {
    return { ...ownProps, ...propsFromState };
  }
)(loginForm);



// WEBPACK FOOTER //
// ./src/scenes/login/containers/Login.js